import { useState } from "react";
import Button from "../Button";
import '../Modal/Modal.scss'


    


// const Modal = ({header,text,btnClose,actions}) =>{
// return(
//         <>
        //  <div className="modal__wrapper" >
        //         <div className="modal__wrap">
        //             <div className="modal__wrap-bg"></div>
        //              <div className="modal__header">
        //                 <h4 className="modal__header-title">{header}</h4>
        //                 <Button text='&#10006;' className='button_close' onClick={btnClose}/>
        //             </div>
        //         <div className="modal__main">
        //             <p className="modal__main-text">{text}</p>
        //         </div>
        //         <div className="modal__footer">
        //             {actions}
        //         </div>
        //         </div>
        //     </div>
//         </>
//     )
// }

// export default Modal

import { Dialog } from "@mui/material";

const Modal = ({header,text,btnClose,actions}) =>{


    const [open,setOpen] = useState(true)
    return(
            <>
            <Dialog open={open}>
            
                <div className="modal__wrap">
                    
                    <div className="modal__header">
                        <h4 className="modal__header-title">{header}</h4>
                        <Button text='&#10006;' className='button_close' onClick={btnClose}/>
                    </div>
                    <div className="modal__main">
                        <p className="modal__main-text">{text}</p>
                    </div>
                    <div className="modal__footer">
                        {actions}
                    </div>
                </div>
            
            </Dialog>
            </>
        )
    }
    
    export default Modal